'use client';
import React from 'react';
import { Button as PButton } from '@pezeshk-book/ui-kit';
import { useParams } from 'next/navigation';
import { ButtonProps } from '@pezeshk-book/ui-kit/button/button.props';
import { LocaleTypes } from '@dictionaries-types';

const Button = ({ ...rest }: ButtonProps) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <PButton dir={lang === 'en' ? 'rtl' : 'ltr'} {...rest} />
  );
};

export default Button;
